import { translations } from "../content/translations";

let lang = "en";

let currentEmail = "";
let countdownInterval;


// Helper to POST JSON and parse response
async function jsonPost(url, formName) {
  const form = document.getElementById(formName);
  const formData = new FormData(form);
  formData.append("formName", formName);
  const result = await fetch(url, {
    method: "POST",
    body: formData,
  });
  return result;
}

// Start 30-second countdown for “Resend”
function startTimer() {
  const timerSpan = document.getElementById("timer");
  const timerWrapper = document.getElementById("timerWrapper");
  const resendBtn = document.getElementById("resendBtn");

  let t = 30;
  resendBtn.disabled = true;
  resendBtn.classList.toggle("btn-outline-secondary", true);
  resendBtn.classList.toggle("btn-warning", false);
  timerWrapper.style.display = "inline-block";
  timerSpan.textContent = t;
  countdownInterval = setInterval(() => {
    t--;
    timerSpan.textContent = t;
    if (t <= 0) {
      clearInterval(countdownInterval);
      resendBtn.disabled = false;
      timerWrapper.style.display = "none";
      resendBtn.classList.toggle("btn-outline-secondary", false);
      resendBtn.classList.toggle("btn-warning", true);
    }
  }, 1000);
}

function renderContacts(data) {
  document.getElementById("step2").style.display = "none";
  const step3 = document.getElementById("step3");
  step3.style.display = "block";

  const container = document.getElementById("contactsContainer");
  container.innerHTML = "";

  data.contacts.forEach((c, idx) => {
    const div = document.createElement("div");
    div.className = "form-check";

    const input = document.createElement("input");
    input.className = "form-check-input";
    input.type = "radio";
    input.name = "contact";
    input.id = `contact${idx}`;
    input.value = c.id;

    if (idx === 0) input.checked = true;

    const label = document.createElement("label");
    label.className = "form-check-label";
    label.htmlFor = input.id;
    label.textContent = c.name;

    div.appendChild(input);
    div.appendChild(label);
    container.appendChild(div);
  });
}

// Step 1: send code to email
export const sendCodeBtn = async () => {
  const emailInput = document.getElementById("emailInput");
  const email = emailInput.value.trim();
  if (!email) return alert("Please enter a valid email");
  try {
    await jsonPost(`send-code`, "stepOne");
    currentEmail = email;
    const step1 = document.getElementById("step1");
    const step2 = document.getElementById("step2");
    const emailDisplay = document.getElementById("emailDisplay");
    step1.style.display = "none";
    step2.style.display = "block";
    emailDisplay.value = email;
    startTimer();
  } catch (err) {
    alert("Error sending code: " + err.message);
  }
};

export const resendBtn = async () => {
  try {
    await jsonPost(`send-code`, "stepOne");
    clearInterval(countdownInterval);
    startTimer();
  } catch (err) {
    return alert("Error resending code: " + err.message);
  }
};

// Change email: clear fields and go back
export const changeEmailBtn = async () => {
  const codeInput = document.getElementById("codeInput");
  const emailInput = document.getElementById("emailInput");
  emailInput.value = "";
  codeInput.value = "";
  clearInterval(countdownInterval);
  step2.style.display = "none";
  step1.style.display = "block";
};

// Step 2: verify code, then lookup partner in Odoo
export const verifyCodeBtn = async () => {
  const code = codeInput.value.trim();
  if (!code) return alert("Please enter the code");
  try {
    const response = await jsonPost(`verify-code`, "stepTwo");
    const data = await response.json();
    if (data.contacts.length) {
      renderContacts(data);
    } else {
      document.getElementById("step2").style.display = "none";
      const step4 = document.getElementById("step4");
      step4.style.display = "block";
    }
  } catch (err) {
    alert("Error: " + err.message);
  }
};

export const investorSubscription = async () => {
  const result = await jsonPost(`investor-subscribe`, "stepThree");

  if (result.status === 200) {
    localStorage.setItem(
      "successMessage",
      translations.successInvestorMessage[lang]
    );
    window.location.href = "/success";
  } else {
    window.location.href = "/error";
  }
};

export const investorSubmission = async () => {
  const result = await jsonPost(`investor-submit`, "investorSubmit");

  if (result.status === 200) {
    localStorage.setItem(
      "successMessage",
      translations.successInvestorMessage[lang]
    );
    window.location.href = "/success";
  } else {
    window.location.href = "/error";
  }
};
